import React, { FC } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { Breakpoints } from 'logic/hooks/use-breakpoints';
import { colors } from 'styles/colors';
import { SupportHints, useHasSupportHints } from './support-hints';

/**
 * Slim counterpart of the sidebar support hints, shown between content and footer
 * as long as the sidebar itself is hidden (see `LayoutSidebar`).
 */
const MobileSupportHintsBar = styled.section`
  ${tw`p-4`};
  margin: 0 16px 24px 16px;
  background-color: ${colors.white};
  border-radius: 10px;

  @media (${Breakpoints.minTablet}) {
    margin: 0 0 24px 0;
  }

  @media (${Breakpoints.minWideDesktop}) {
    display: none;
  }
`;

export const MobileSupportHints: FC = () => {
  const hasSupportHints = useHasSupportHints();

  if (!hasSupportHints) {
    return null;
  }

  return (
    <MobileSupportHintsBar>
      <SupportHints layout="inline" />
    </MobileSupportHintsBar>
  );
};
